export const systemKeywords = {
    crm: {
        title: "CRM – Quản lý quan hệ khách hàng",
        keywords: [
        "Chăm sóc khách hàng ngành xây dựng",
        "Phần mềm CRM doanh nghiệp vừa và nhỏ",
        "Quản lý tương tác khách hàng chuyên sâu",
        "CRM cho ngành dịch vụ",
        "CRM ngành phân phối và bán lẻ",
        "CRM kết nối đa kênh",
        "Theo dõi lịch sử giao dịch khách hàng",
        "Quản lý đội ngũ bán hàng",
        "CRM cho quản lý cơ hội kinh doanh",
        "Quản lý pipeline bán hàng hiệu quả",
        "CRM tích hợp ERP",
        "Phần mềm CRM cho công ty sản xuất",
        "CRM quản lý hợp đồng kinh doanh",
        "Tự động hóa quy trình chăm sóc khách hàng",
        "CRM phân tích khách hàng tiềm năng",
        "Quản lý đội nhóm bán hàng số hóa",
        "CRM ngành giáo dục - đào tạo",
        "CRM ngành vận tải"
        ]
    },
    dms: {
        title: "DMS – Quản lý bán hàng",
        keywords: [
        "Phòng điều phối bán hàng đa kênh",
        "Phần mềm quản lý báo giá tự động",
        "Quản lý đơn hàng toàn diện",
        "Quản lý đội ngũ bán hàng lưu động",
        "Theo dõi mục tiêu doanh số",
        "Quản lý hợp đồng bán hàng",
        "Tích hợp kho vận với bán hàng",
        "Bán hàng ngành thực phẩm - vật liệu xây dựng",
        "Phần mềm kích hoạt bán hàng nhanh",
        "Quản lý khuyến mãi bán hàng",
        "Quản lý đơn hàng online",
        "Quản lý doanh số theo khu vực",
        "Tích hợp bán hàng với kế toán",
        "Phân tích doanh thu từng sản phẩm",
        "Quản lý số liệu bán hàng real-time",
        "Đánh giá hiệu quả CTKM",
        "Phần mềm bán hàng cho đại lý, NPP",
        "SMS bán hàng - sản xuất - vận tải",
        "Bán hàng – Giao hàng – Thu tiền trên một nền tảng"
        ]
    },
    pm: {
        title: "Project Management – Quản lý dự án",
        keywords: [
        "Phần mềm quản lý dự án xây dựng",
        "Quản lý tiến độ dự án số hóa",
        "Quản lý nhân lực và phân bổ nguồn lực dự án",
        "Quản lý chi phí dự án doanh nghiệp",
        "Giám sát tiến trình thực hiện công việc",
        "Theo dõi lịch trình nhóm dự án",
        "Báo cáo dự án toàn diện",
        "Lập kế hoạch và kiểm soát dự án",
        "Quản lý rủi ro dự án công nghệ",
        "Phần mềm quản lý dự án sản xuất gia công",
        "Quản lý hạng mục dự án đa ngành nghề",
        "PM quản lý tài liệu dự án online",
        "Quản lý giao việc - teamwork dự án",
        "Giám sát tiến độ theo biểu đồ Gantt",
        "Đánh giá hiệu quả dự án sau triển khai",
        "Quản lý dự án đầu tư công nghệ mới",
        "Quản lý nhiều dự án cùng lúc",
        "Báo cáo KPIs dự án số hóa"
        ]
    },
    hrm: {
        title: "HRM – Quản lý nhân sự",
        keywords: [
        "Phần mềm quản lý nhân sự hiện đại",
        "Quản lý chấm công thông minh",
        "Quản lý tuyển dụng online",
        "Quản lý đánh giá hiệu suất nhân sự",
        "Quản lý đào tạo nhân viên số hóa",
        "Quản lý phúc lợi doanh nghiệp",
        "Quản lý hồ sơ nhân viên",
        "Quản lý bảng lương tự động",
        "Quản lý hợp đồng lao động ngành sản xuất",
        "Giải pháp HRM tích hợp ERP",
        "Quản lý nhân sự đa chi nhánh",
        "Phần mềm HRM cho công ty dịch vụ",
        "HRM quản lý nghỉ phép",
        "HRM tích hợp quản lý KPI nhân viên",
        "Quản lý thay đổi vị trí nhân sự",
        "Đánh giá đào tạo đội ngũ",
        "Quản lý nhóm dự án",
        "Quản lý lương thưởng, phúc lợi",
        "Quản lý nhân sự ngành vận tải/logistics"
        ]
    },
    platformAI: {
        title: "AI Procurement Platform",
        keywords: [
            "Sàn giao dịch mua bán doanh nghiệp AI",
            "Kết nối doanh nghiệp với nhà cung cấp AI",
            "Ứng dụng AI trong đấu thầu",
            "Công nghệ AI tối ưu hóa mua hàng",
            "Quản lý hợp đồng mua hàng AI",
            "Phân tích dữ liệu giao dịch B2B",
            "Gợi ý sản phẩm bằng AI",
            "Dự báo nhu cầu mua hàng tự động",
            "Quản lý quá trình đấu thầu thông minh",
            "AI cho quy trình procurement",
            "AI phân tích lịch sử giao dịch NCC",
            "AI chấm điểm minh bạch NCC",
            "Phần mềm AI dự báo giá vật tư",
            "Đấu giá trực tuyến bằng AI",
            "Quản lý nhà cung cấp thông minh AI",
            "Chuỗi cung ứng kết nối AI",
            "Dự báo xu hướng mua hàng thị trường",
            "AI lên kế hoạch mua sắm tự động",
            "AI chọn nhà cung cấp tốt nhất",
            "AI procurement platform Việt Nam",
        ]
    },
    erpMini: {
        title: "Mini ERP",
        keywords: [
            "Mini ERP cho doanh nghiệp vừa và nhỏ",
            "ERP tích hợp đa chức năng",
            "ERP ngành xây dựng và phân phối",
            "Quản lý vận hành doanh nghiệp toàn diện",
            "ERP cho doanh nghiệp sản xuất",
            "Quản lý tài chính doanh nghiệp số hóa",
            "Tích hợp nhân sự - bán hàng - kho",
            "Giải pháp ERP chi phí tối ưu",
            "Mini ERP kết nối hệ thống bán hàng",
            "Tối ưu hóa vận hành với Mini ERP",
            "ERP ngành dịch vụ - Spa - Nhà hàng",
            "Mini ERP kết nối B2B",
            "Quản lý nhân sự trên Mini ERP",
            "Quản lý dự án doanh nghiệp ERP",
            "Lập kế hoạch sản xuất bằng Mini ERP",
            "ERP quản lý vận tải",
            "Mini ERP kho vận và logistics",
            "Quản lý báo cáo chứng từ ERP",
            "Mini ERP quản lý phòng ban/chức năng riêng",
            "Tích hợp Mini ERP với phân tích AI",
        ]
    },
    pms: {
        title: "PMS - Quản lý mua hàng",
        keywords: [
            "Tối ưu hóa quy trình mua hàng",
            "Đấu thầu doanh nghiệp online",
            "B2B procurement platform Việt Nam",
            "Quản lý nhà cung cấp – NCC",
            "Theo dõi đơn mua hàng doanh nghiệp",
            "Phân tích chi phí mua hàng tự động",
            "Đánh giá năng lực nhà cung cấp",
            "Quản lý hóa đơn và hợp đồng mua hàng",
            "Phần mềm mua sắm nội bộ thông minh",
            "Quản lý tiêu chuẩn kiểm tra vật tư",
            "Đấu giá mua hàng AI",
            "Quản lý quy trình phê duyệt mua hàng",
            "Theo dõi tồn kho vật tư mua mới",
            "Quản lý chi phí logistics khi mua hàng",
            "Quản lý hợp đồng nhà cung cấp B2B",
            "Giám sát hiệu quả công tác procurement",
            "Chuỗi cung ứng số hóa bằng PMS",
            "Quản lý lịch sử nhà cung cấp",
            "Quản lý KPI phòng mua hàng",
            "Minh bạch quy trình chọn NCC",
        ]
    },
    mes: {
        title: "MES - Quản lý sản xuất",
        keywords: [
            "Quản lý sản xuất thông minh MES",
            "Theo dõi sản lượng nhà máy thời gian thực",
            "Tối ưu hóa máy móc thiết bị sản xuất",
            "Giám sát quy trình vận hành sản xuất online",
            "Quản lý chất lượng sản phẩm sản xuất",
            "Phần mềm kiểm soát nguyên vật liệu",
            "Tích hợp thiết bị IoT trong sản xuất",
            "MES cho doanh nghiệp vừa và nhỏ",
            "MES tích hợp AI phân tích sản xuất",
            "Quản lý bảo trì nhà máy thông minh",
            "MES cho ngành thực phẩm",
            "Tối ưu hóa quy trình sản xuất ERP",
            "Phân tích hiệu suất máy móc với MES",
            "MES kiểm soát an toàn sản xuất",
            "Quản lý bảng ca sản xuất tự động",
            "MES tích hợp hệ thống cảm biến IoT",
            "Phần mềm phân tích năng suất nhà máy",
            "MES kiểm tra chất lượng sản phẩm tự động",
            "MES xuất báo cáo sản xuất real-time",
        ]
    },
    tms: {
        title: "TMS - Quản lý vận tải",
        keywords: [
            "Quản lý vận tải hàng hóa đường bộ",
            "Tối ưu hóa lộ trình giao nhận",
            "Tự động lập kế hoạch vận tải",
            "Quản lý đội xe doanh nghiệp",
            "Theo dõi trạng thái giao hàng thời gian thực",
            "Chấm công tài xế tự động",
            "Quản lý chi phí giao nhận vận chuyển",
            "Tối ưu hóa tuyến đường vận chuyển",
            "Vận tải hàng hóa thông minh",
            "Quản lý đơn vận chuyển logistics",
            "TMS tích hợp quản lý kho",
            "Quản lý thông tin xe tải real-time",
            "Quản lý lịch trình giao nhận hàng hóa",
            "Phân tích hiệu suất vận tải của doanh nghiệp",
            "TMS cho công ty vận tải nội địa",
            "TMS kết nối ERP quản lý vận tải",
            "Quản lý lịch sử vận chuyển hàng hóa",
            "Tự động hóa báo cáo vận tải",
        ]
    },
    wms: {
        title: "WMS - Quản lý kho",
        keywords: [
            "Quản lý kho hàng thông minh",
            "Quản lý xuất nhập tồn kho chính xác",
            "Phần mềm theo dõi vị trí lưu trữ hàng hóa",
            "Tối ưu hóa dòng chảy kho bãi",
            "Quản lý tồn kho đa địa điểm",
            "Kiểm kê hàng hóa tự động",
            "Quản lý kho ngành vật liệu xây dựng",
            "Báo cáo kho hàng real-time",
            "Quản lý luân chuyển hàng hóa tích hợp ERP",
            "Quản lý vận hành kho bãi số hóa",
            "Quản lý xuất nhập kho cho nhà máy",
            "WMS tích hợp với phần mềm bán hàng",
            "WMS cho doanh nghiệp sản xuất",
            "Phát hiện hàng tồn kho chậm luân chuyển",
            "Quản lý vị trí lưu trữ tự động",
            "Quản lý kho ngành thực phẩm",
            "Quản lý chuỗi cung ứng vật tư",
            "WMS tích hợp AI phân tích",
            "Quản lý kho đa kho bãi tiện ích",
            "Quản lý chi phí vận hành kho",
        ]
    },
    eam: {
        title: "EAM - Quản lý tài sản",
        keywords: [
            "Quản lý tài sản cố định toàn diện",
            "Theo dõi tuổi thọ tài sản doanh nghiệp",
            "Quản lý bảo trì sửa chữa tài sản",
            "Kiểm soát lịch sử sử dụng thiết bị",
            "Quản lý thiết bị ngành dịch vụ",
            "Phần mềm đăng ký tài sản tích hợp ERP",
            "Quản lý bảo hiểm tài sản doanh nghiệp",
            "Quản lý tài sản ngành vận tải",
            "Tích hợp dữ liệu tài sản số hóa",
            "Quản lý rủi ro vận hành tài sản",
            "EAM ngành bất động sản",
            "EAM quản lý tài sản cho doanh nghiệp lớn",
            "Quản lý kiểm kê tài sản nhanh chóng",
            "Quản lý tài sản xây dựng không gian số",
            "Quản lý bảo dưỡng thiết bị tự động",
            "EAM tích hợp với quản lý kho WMS",
            "Quản lý lịch sử kiểm tra tài sản",
            "Quản lý tài sản ngành dịch vụ - nhà hàng",
            "EAM số hóa tài sản logistics",
            "Quản lý tài sản di động real-time",
        ]
    },
    apexLink: {
        title: "APExLINK",
        keywords: [
            "Kết nối dữ liệu Web2 với blockchain",
            "Giải pháp blockchain trung gian cho doanh nghiệp",
            "Tích hợp blockchain vào hệ thống ERP",
            "Quản lý thông tin trên blockchain",
            "Blockchain tăng bảo mật dữ liệu doanh nghiệp",
            "ApexLink kết nối BNB, Ethereum, Solana",
            "Blockchain cho chuỗi cung ứng doanh nghiệp",
            "Dự phòng dữ liệu blockchain Gateway",
            "Phần mềm hỗ trợ tích hợp blockchain",
            "Giải pháp blockchain cho doanh nghiệp số hóa",
            "Blockchain đảm bảo tính toàn vẹn dữ liệu",
            "Quản lý hợp đồng thông minh blockchain",
            "Blockchain cho ngành logistics/vận tải",
            "Giám sát xuất nhập dữ liệu chuỗi cung ứng",
            "Blockchain số hóa hồ sơ dự án đầu tư",
            "Lưu trữ dữ liệu on-chain, off-chain",
            "Blockchain quản lý bảo trì thiết bị",
            "Tích hợp blockchain cho ngành xây dựng",
            "Quản lý lịch sử giao dịch blockchain",
            "ApexLink cho doanh nghiệp vừa và nhỏ",
        ]
    },
};
